export function dialog() {
	if (document.querySelector('dialog')) {
		const openDialog = document.querySelectorAll('.open-dialog')
		const closeDialog = document.querySelectorAll('.close-dialog')
		const dialog = document.querySelectorAll('dialog')

		const openModal = (item) => {
			const firstElement = item.querySelector('a, button, input, select, textarea')
			if (firstElement) firstElement.focus()
			document.querySelector('dialog[id*="' + item.getAttribute('data-dialog') + '"').showModal()
		}

		const closeModal = (item) => {
			document.querySelector('dialog[id*="' + item.getAttribute('data-dialog') + '"').close()
		}

		openDialog.forEach((item) =>
			item.addEventListener('click', () => {
				openModal(item)
			})
		)

		openDialog.forEach((item) => {
			item.addEventListener('keydown', (event) => {
				if (event.key === 'Enter') {
					event.preventDefault()
					openModal(item)
				}
			})
		})

		closeDialog.forEach((item) =>
			item.addEventListener('click', () => {
				closeModal(item)
			})
		)

		closeDialog.forEach((item) => {
			item.addEventListener('keydown', (event) => {
				if (event.key === 'Enter') {
					event.preventDefault()
					closeModal(item)
				}
			})
		})

		dialog.forEach((item) => {
			item.addEventListener('click', (e) => {
				const dialogDimensions = item.getBoundingClientRect()

				if (!e.target.form && (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom)) {
					item.close()
				}
			})
		})
	}
}
